<template>
  <div class="flex flex-col items-center justify-center text-center py-16 px-6">
    <div
      class="flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-muted text-primary mb-6"
      aria-hidden="true"
    >
      <component :is="iconComponent" class="h-8 w-8" />
    </div>
    <h3 class="text-h4 mb-2">{{ title }}</h3>
    <p class="text-caption max-w-sm mb-6">{{ description }}</p>
    <slot name="action" />
  </div>
</template>

<script>
import { Inbox, Search, Lock, FileQuestion } from '@lucide/vue'

const icons = { inbox: Inbox, search: Search, lock: Lock, file: FileQuestion }

export default {
  name: 'BaseEmpty',
  props: {
    title: { type: String, default: 'No data found' },
    description: { type: String, default: 'There is nothing to display here yet.' },
    icon: { type: String, default: 'inbox' },
  },
  computed: {
    iconComponent() {
      return icons[this.icon] || Inbox
    },
  },
}
</script>
